export enum ProcessTiming {
  ProcessImmediately = '1',
  HoldBeforePayByTime = '0',
  HoldFromReceipt = '2'
}
